/**
 * Sets the correct URL param separator based on existence of `?`
 * @param {string} url - A string value to be checked for existing param separators
 */
export const setParamSeparator = url => (url && url.includes('?') ? '&' : '?');
